import { useSeo } from "../hooks/useSeo";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { formatHuf } from "../context/CartContext";

export default function OrderSuccess() {
  useSeo({
    title: "Sikeres rendelés | Hair Elixir Hungary",
    description: "",
    noindex: true,
  });
  const [order, setOrder] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("he-last-order");
      if (raw) setOrder(JSON.parse(raw));
    } catch (e) {
      // ignore
    }
  }, []);

  return (
    <main data-testid="page-order-success" className="pt-32 md:pt-40 pb-32 bg-[color:var(--he-bg)] min-h-screen">
      <section className="he-container max-w-3xl text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full border border-[color:var(--he-gold)]">
          <Check size={22} strokeWidth={1.5} className="text-[color:var(--he-gold)]" />
        </div>
        <p className="overline mt-10 mb-5">Köszönjük a rendelést</p>
        <h1
          className="font-serif-display tracking-[-0.022em] leading-[1.04]"
          style={{ fontSize: "clamp(2.4rem, 5.6vw, 5rem)", fontWeight: 400 }}
        >
          A megrendelést <span className="italic text-[color:var(--he-gold)]">megkaptuk.</span>
        </h1>
        <p className="mt-7 text-[color:var(--he-ink-soft)] font-light leading-[1.7] max-w-xl mx-auto">
          E-mailben hamarosan visszaigazolást küldünk a részletekkel és a kézbesítés
          várható időpontjával.
        </p>

        {order && (
          <div className="mt-14 bg-[color:var(--he-cream)] border border-[color:var(--he-line)] p-7 md:p-10 text-left">
            <div className="flex items-baseline justify-between mb-7 pb-5 border-b border-[color:var(--he-line)]">
              <div>
                <p className="overline-xs text-[color:var(--he-ink-soft)]">Rendelési azonosító</p>
                <p className="font-serif-display text-2xl mt-1" data-testid="order-id">{order.id}</p>
              </div>
              <p className="font-serif-display text-2xl" data-testid="order-total">
                {formatHuf(order.total)}
              </p>
            </div>
            <ul className="divide-y divide-[color:var(--he-line)]">
              {order.items.map((it) => (
                <li key={it.key} className="flex gap-4 py-4">
                  <div className="w-14 h-18 flex-shrink-0 overflow-hidden bg-[color:var(--he-bg)]">
                    <img src={it.image} alt={it.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="overline-xs text-[color:var(--he-ink-soft)]">{it.length} · {it.qty} db</p>
                    <p className="font-serif-display text-base mt-1">{it.name}</p>
                  </div>
                  <p className="font-serif-display text-sm whitespace-nowrap">
                    {formatHuf(it.unitPrice * it.qty)}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-14">
          <Link to="/termekek" data-testid="success-continue" className="btn-outline-gold">
            <span>Tovább vásárlás</span>
            <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </main>
  );
}
